/**
 * uso base di i18n

 installare
 npm install -g ngx-i18nsupport

 ==> crare i files messages.$lang.xlf
 da console nella root del progetto ng xi18n --output-path src/i18n && xliffmerge --profile xliffmerge.json

 ==> avviare il server interno specificando la lingua
 ng serve --host nemo-gui.localhost --aot --i18n-file=src/i18n/messages.$leng.xlf --locale=$leng --i18n-format=xlf --env=$leng
 es
 ng serve --host nemo-gui.localhost --aot --i18n-file=src/i18n/messages.it.xlf --locale=it --i18n-format=xlf --env=local

 ==> Building
 ng build --output-path dist/$lang --aot -prod --bh /$lang/ --i18n-file=src/i18n/messages.$lang.xlf --locale=$lang --i18n-format=xlf --env=$env
 es
 ng build --output-path dist/it --aot -prod --bh /it/ --i18n-file=src/i18n/messages.it.xlf --locale=it --i18n-format=xlf --env=prod

 dove

 --output-path (Path) (Default: null) Path where output will be placed.
 aliases: -op <value>, --outputPath <value>

 --aot (Boolean) Build using Ahead of Time compilation.
 aliases: -aot

 --base-href (String) Base url for the application being built.
 aliases: -bh <value>, --baseHref <value>
 <!--opzionale fa finire l'url con /$lang-->

 --i18n-file (String) Localization file to use for i18n.
 aliases: --i18nFile <value>

 --locale (String) Locale to use for i18n.
 aliases: --locale <value>

 --i18n-format (String) (Default: xlf) Output format for the generated file.
 aliases: -f <value>, -xmb (--i18n-format=xmb), -xlf (--i18n-format=xlf), --xliff (--i18n-format=xof), --i18nFormat <value>

 */

import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

if (environment.production) {
	enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule);
